import type { Downloader } from '@mimir/common/types/downloader';
import { createDefaultDownloader } from '@mimir/client-common/download/defaultDownloader';
import { DefaultBackendOps } from '@mimir/client-common/util/defaultBackendOperations';
import type { BackendClient } from '@mimir/common/util/backendClient';
import { ConsoleSLogger } from '@mimir/common/log/consoleSLogger';
import { makeBrowserFetch } from '../browser/browserFetch';
import { DefaultResourceAccessor } from '@mimir/common/io/defaultResourceAccessor';
import { DefaultMxfRewrapItemProvider } from '@mimir/client-common/util/defaultMxfRewrapItemProvider';
import type { Vfs } from '@mimir/common/types/vfs';
import type { HighPrecisionMonotonicClock } from '@mimir/common/types/highPrecisionMonotonicClock';
import { createTsToFragmentedMp4TransformStream } from '@mimir/common/mpegts/tsToFragmentedMp4TransformStream';
import { monotonicClock } from '@mimir/common/async/timing';

export function createUiDefaultDownloader(
  vfs: Vfs,
  windowGlobal: typeof window,
  backendClient: BackendClient,
  clock: HighPrecisionMonotonicClock | null,
): Downloader {
  const backendOps = new DefaultBackendOps(backendClient);
  const logger = new ConsoleSLogger();
  const fetch = makeBrowserFetch(windowGlobal).fetch;

  const resourceAccessor = new DefaultResourceAccessor({ fetch, vfs, clock: monotonicClock(() => performance.now()) });
  const mxfRewrapItemProvider = new DefaultMxfRewrapItemProvider(backendClient, null);

  return createDefaultDownloader({
    mediaSegmentsUrlProvider: backendOps,
    logger,
    resourceAccessor,
    mxfRewrapItemProvider,
    vfs,
    clock,
    tsToFragmentedMp4TransmuxStreamFactory: createTsToFragmentedMp4TransformStream,
  });
}
